export default "__VITE_ASSET__DcHG8_LP__"